import { Box, Divider, Typography } from "@mui/material";
import { useMarathonTabForm } from "features/createEditMarathon/model/hooks/marathonTabsHooks/useMarathonTabForm";
import { useEffect, useState } from "react";
import { KgTab } from "./components/languageTabs/KgTab";
import { RuTab } from "./components/languageTabs/RuTab";
import { EnTab } from "./components/languageTabs/EnTab";
import { useNavigate, useParams } from "react-router-dom";
import {
  ADMIN_PANEL_PATH,
  MARATHONS_PATH,
} from "pages/paths";
import LeaveConfirmationModal from "../../modals/leaveModal/LeaveConfirmationModal";
import { useTranslation } from "react-i18next";
import { removeFromLocal } from "shared/services/getLocal";
import { ButtonGroup } from "./components/buttonGroup/ButtonGroup";
import { LanguageTabPanel } from "./components/languageTabs/LanguageTabPanel";
import { CustomTabPanel } from "./components/languageTabs/CustomTabPanel";

const MarathonContent = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const params = useParams();
  const isEditMode = /\d/.test(params.id || "");

  const [isConfirmationModalOpen, setConfirmationModalOpen] = useState(false);

  const getInitialTab = () => {
    if (isEditMode && params.language) {
      const languageMap: Record<string, number> = { ru: 0, en: 1, kg: 2 };
      return languageMap[params.language] || 0;
    }

    if (!isEditMode) {
      const urlParams = new URLSearchParams(window.location.search);
      const language = urlParams.get("language");
      if (language) {
        const languageMap: Record<string, number> = { ru: 0, en: 1, kg: 2 };
        return languageMap[language] || 0;
      }
    }
    return 0;
  };

  const [value, setValue] = useState(getInitialTab());

  useEffect(() => {
    const newTabValue = getInitialTab();
    setValue(newTabValue);
  }, [params.language, isEditMode, window.location.search]);

  const { errors, isDirty } = useMarathonTabForm();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [value]);

  const closeModalConfirm = () => {
    if (isDirty) {
      navigate(`/${ADMIN_PANEL_PATH}/${MARATHONS_PATH}`);
      setConfirmationModalOpen(false);
      removeFromLocal("marathonFormData");
    }
  };

  return (
    <Box sx={{ width: "100%", typography: "body1" }}>
      <Box
        sx={{
          backgroundColor: "#fff",
          borderRadius: "0 0 16px 16px",
          paddingTop: "10px",
          marginBottom: "20px",
        }}
      >
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              gap: "16px",
              mt: "20px",
            }}
          >
            <Typography
              sx={{
                fontSize: "16px",
                lineHeight: "24px",
                fontWeight: 500,
                fontFamily: "Raleway",
              }}
            >
              {t("createMarathon.mainInfo")}
            </Typography>
            <Divider sx={{ flex: "1", background: "#ECF2F7" }} />
          </Box>
          <LanguageTabPanel
            value={value}
            errors={errors}
            isEditMode={isEditMode}
            setValue={setValue}
            id={params.id} />
        </Box>
        <CustomTabPanel value={value} index={0}>
          <RuTab />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <EnTab />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <KgTab />
        </CustomTabPanel>
      </Box>
      <Box>
        <ButtonGroup
          value={value}
          isEditMode={isEditMode}
          params={params}
          setConfirmationModalOpen={setConfirmationModalOpen}
          isDirty={isDirty}
        />
        <LeaveConfirmationModal
          isModalOpen={isConfirmationModalOpen}
          setIsModalOpen={setConfirmationModalOpen}
          actionName={"Close"}
          instanceName=""
          message={"closeFormWithoutSaving"}
          handleAction={closeModalConfirm}
        />
      </Box>
    </Box>
  );
};

export default MarathonContent;
